// extracted by mini-css-extract-plugin
export default {"bold":"EligibilityStandards_bold__UEu1T","labelMargin":"EligibilityStandards_labelMargin__kEkAw","criteriaList":"EligibilityStandards_criteriaList__ts0ov"};